import { render, staticRenderFns } from "./preDetails.vue?vue&type=template&id=407e8fa9&scoped=true&"
import script from "./preDetails.vue?vue&type=script&lang=js&"
export * from "./preDetails.vue?vue&type=script&lang=js&"
import style0 from "./preDetails.vue?vue&type=style&index=0&id=407e8fa9&prod&lang=less&"
import style1 from "./preDetails.vue?vue&type=style&index=1&id=407e8fa9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e8fa9",
  null
  
)

export default component.exports